import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onOpenPersonSources = action('onOpenPersonSources', event => ({
    event,
    owaType: 'openPersonSources',
})) as OwaNovaActionUnion<'openPersonSources'>;
